import { useNavigate } from 'react-router-dom';

/**
 * A back button's handler: the previous screen if there is one in the app,
 * else `fallback`. A page opened straight from a link or a notification is
 * the first in the app's history, and going back from it would do nothing or
 * leave the app.
 *
 * React Router keeps each entry's position in history.state.idx: 0 for the
 * page the app was loaded on, +1 per push, unchanged by a replace. (The
 * location key isn't enough: a replace — e.g. switching week on Ops — gives
 * the first page a new key.)
 */
export function useBack(fallback: string): () => void {
  const nav = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) nav(-1);
    else nav(fallback, { replace: true });
  };
}
